<template>
    <header class="site-header" v-if="!Edicao">
        <div class="logo">
            <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
            <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 90%; height: 90%;" />
            <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
            <img src="@/assets/logoLastro.jpg" v-if="nomeEmpresa == 'Lastro'" style="width: 100%; height: 100%;" />
        </div>
        <nav class="navigation">
            <ul>
                <li><button type="button" v-if="configuracaoToken != 'S'" class="button button-light"
                        @click="alterarSenha()" style="cursor: pointer;">Alterar senha</button></li>
                <li><button type="button" @click="logoff" style="cursor: pointer;" class="submit-button">Logoff</button>
                </li>
            </ul>
        </nav>
    </header>
    <div class="container" :class="{ containerRJI: nomeEmpresa == 'RJI' }">
        <div class="header">
            <h2 v-if="!Edicao" class="form-header">Cadastro</h2>
            <div class="info__headers" v-if="!Edicao">
                <div class="info__resumo">
                    <div class="navegacao">
                        <a href="javascript:;" class="link" :class="{ active: tab == 0, preenchido: tab > 0 }"
                            @click="selectTab(0)">
                            Informações
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 1, preenchido: tab > 1 }"
                            @click="selectTab(1)">
                            Procuradores
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 2, preenchido: tab > 2 }"
                            @click="selectTab(2)">
                            Dados Financeiros
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 3, preenchido: tab > 3 }"
                            @click="selectTab(3)">
                            Dados Bancários
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 4, preenchido: tab > 4 }"
                            @click="selectTab(4)">
                            Endereços
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 5, preenchido: tab > 5 }"
                            @click="selectTab(5)">
                            Upload de Documentos
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 6, preenchido: tab > 6 }"
                            @click="selectTab(6)">
                            Declarações
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 7 }" @click="selectTab(7)">
                            Produtos
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="tab == 0" class="headerAtivo">
                <Informacoes v-if="informacoesBasicas" ref="form_0" :Edicao="Edicao" />
                <div v-if="!informacoesBasicas" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 1" class="headerAtivo">
                <Representantes :Edicao="Edicao" ref="form_1" />
            </div>
            <div v-if="tab == 2" class="headerAtivo">
                <DadosFinanceiros v-if="informacoesFinanceiras" ref="form_2" :informacoesFinanceiras="informacoesFinanceiras"
                    :Edicao="Edicao" />
                <div v-if="!informacoesFinanceiras" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 3 && informacoesBancarias" class="headerAtivo">
                <DadosBancarios v-if="informacoesBancarias" ref="form_3" :Edicao="Edicao" />
                <div v-if="!informacoesBancarias" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 4" class="headerAtivo">
                <Endereco v-if="informacoesBasicas" ref="form_4" :informacoesBasicas="informacoesBasicas" :Edicao="Edicao" />
                <div v-if="!informacoesBasicas" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 5" class="headerAtivo">
                <UploadDocumentos :Edicao="Edicao" ref="form_5" />
            </div>
            <div v-if="tab == 6" class="headerAtivo">
                <Declaracoes v-if="informacoesDeclaracoes" ref="form_6" :informacoesDeclaracoes="informacoesDeclaracoes"
                    :Edicao="Edicao" />
                <div v-if="!informacoesDeclaracoes" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 7" class="headerAtivo">
                <Produtos :Edicao="Edicao" ref="form_7" />
            </div>

            <div class="footerFormulario">
                <div class="buttonsAcoes">
                    <button class="btnDefault" @click="validarFormularioAtual">{{this.Edicao ? 'Salvar' : 'Salvar e continuar depois'}} </button>
                    <button class="btnBlue btnAvancar" v-if="!Edicao" @click="proximaEtapa">{{this.tab == 7 ? 'Concluir' : 'Avançar'}}</button>
                </div>
            </div>

        </div>
        <ModalAlterarSenha />
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import Informacoes from './Informacoes.vue';
import DadosFinanceiros from './DadosFinanceiros.vue';
import DadosBancarios from './DadosBancarios.vue';
import Endereco from './Endereco.vue';
import Representantes from './Representantes.vue';
import UploadDocumentos from './UploadDocumentos.vue';
import Declaracoes from './Declaracoes.vue';
import Produtos from './Produtos.vue';
import api from '@/api/axios';
import ModalAlterarSenha from '../AlterarSenha/ModalAlterarSenha.vue'

import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
    components: {
        Informacoes,
        DadosFinanceiros,
        DadosBancarios,
        Endereco,
        UploadDocumentos,
        Declaracoes,
        Produtos,
        Representantes,
        ModalAlterarSenha
    },
    props: ['Edicao', 'BloquearSalvarIsolado'],
    name: 'CadastroPF_Passo_1',
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            infoFinanceiras: 'GET_PF_INFO_FINANCEIRAS',
            infoBancarios: 'GET_PF_INFO_BANCARIOS',
            infoDeclaracoes: 'GET_PF_INFO_DECLARACOES',
            salvarInformacoesPF: 'GET_PF_SALVAR_INFO',
            salvarObjInfoBasicas: 'GET_PF_SALVAR_INFO_BASICAS',
            salvarObjInfoFinanceira: 'GET_PF_SALVAR_INFO_FINANCEIRAS',
            salvarObjInfoBancarias: 'GET_PF_SALVAR_INFO_BANCARIAS',
            salvarObjInfoEndereco: 'GET_PF_SALVAR_INFO_ENDERECO',
            ObjSalvarQuestionario: 'GET_SALVAR_QUESTIONARIO',
            salvarObjInfoDeclaracoes: 'GET_PF_SALVAR_INFO_DECLARACOES',
            salvarObjInfoContasAdicionais: 'GET_PF_SALVAR_INFO_CONTAS_ADICIONAIS',
            ObjSalvarInformacoesUploadArquivos: 'GET_SALVAR_INFO_UPLOAD',
            salvarObjInfoBasicosRepresentante: 'GET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES',
            salvarObjConcluir: 'GET_FICHA_CONCLUIR',
            salvarObjDispensaQuestionario: 'GET_PF_PJ_SALVAR_INFO_DISPENSA',
            desabilitarNotificacao: 'GET_SALVAR_INFO_DES_NOTIFICACAO',
            etapasConcluidas: 'GET_ETAPA_CONCLUIDA',
            getConfiguracoes: 'GET_CONFIGURACOES',
            enviarCadastro: 'GET_ENVIAR_CADASTRO',
        }),
        salvouTodasAbas() {
            const { gravarDados } = this;
            return Object.values(gravarDados).every(value => value === 1);
        }
    },
    data() {
        return {
            configuracaoToken: 'N',
            gravarDados: {
                salvarInformacoesPF: 0,
                salvarInformacoesFinanceiras: 0,
                salvarInformacoesBancarias: 0,
                salvarInformacoesDeclaracoes: 0,
                salvarInformacoesUpload: 0,
                salvarInformacoesDispensaQuestionario: 0,
                salvarQuestionario: 0
            },
            nomeEmpresa: '',
            tab: 0,
            informacoesBasicas: null,
            informacoesFinanceiras: this.infoFinanceiras,
            informacoesBancarias: this.infoBancarios,
            informacoesDeclaracoes: this.infoDeclaracoes,
        }
    },
    created() {
        this.ObterDados();
        this.$store.commit('SET_FICHA_CONCLUIR', false);
    },
    async mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.$store.commit('SET_PF_SALVAR_INFO', false);
        if (!this.Edicao) {
            this.$store.commit('SET_ETAPA_CADASTRO', 0)
        } else {
            this.tab = this.etapaCadastro;
        }
        await this.fetchConfiguracao(['Modo de autenticação']);
        this.configuracaoToken = this.getConfiguracoes('Modo de autenticação')?.Valor != '2' ? 'N' : 'S';

        if(this.infoBasicas != null){
            this.informacoesBasicas = this.infoBasicas;
            this.informacoesBasicas.Nome = this.user.NomeRazaoSocial;
        }

        if(this.infoFinanceiras != null)
            this.informacoesFinanceiras = this.infoFinanceiras;
        

        if(this.infoBancarios != null)
            this.informacoesBancarias = this.infoBancarios;
        

        if(this.infoDeclaracoes != null)
            this.informacoesDeclaracoes = this.infoDeclaracoes;
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        houveAlteracaoRepresentantesCriticos() {
            const atual = this.salvarObjInfoBasicas || {};
            const original = this._repSnap || {};

            const toIntOrNull = v =>
                v === null || v === undefined || v === '' ? null : Number(v);

            const situacaoAtual = toIntOrNull(atual.SituacaoLegal);
            const situacaoOriginal = toIntOrNull(original.SituacaoLegal);

            const situacoesComRepresentante = [2, 4, 5];

            const atualTemRepresentante = situacoesComRepresentante.includes(situacaoAtual);
            const originalTemRepresentante = situacoesComRepresentante.includes(situacaoOriginal);

            // 1) Entrou ou saiu do grupo 2/4/5 → alteração crítica
            if (atualTemRepresentante !== originalTemRepresentante) {
                return true;
            }

            // 2) Continua em 2/4/5 → comparar dados do representante
            if (atualTemRepresentante) {
                const norm = v => (v || '').toString().trim();
                const normLower = v => norm(v).toLowerCase();

                const mudouRepresentante =
                    norm(original.NomeRepresentante) !== norm(atual.NomeRepresentante) ||
                    norm(original.CpfRepresentante) !== norm(atual.CpfRepresentante) ||
                    normLower(original.EmailRepresentante) !== normLower(atual.EmailRepresentante);

                if (mudouRepresentante) {
                    return true;
                }
            }

            return false;
        },
        async validarFormularioAtual(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];
            if(this.Edicao && componente?.validarFormulario && refName != 'form_1' && refName != 'form_5'){
                if(componente.validarFormulario(true)){
                    if (componente?.salvarInformacoes) {
                        componente.salvarInformacoes();
                    }else if(this.BloquearSalvarIsolado){
                        this.$store.commit('ADICIONAR_ETAPA_CONCLUIDA', this.tab);
                    }
                }
            }else{
                if (componente?.salvarInformacoes) {
                    componente.salvarInformacoes();
                }else if(this.BloquearSalvarIsolado){
                    this.$store.commit('ADICIONAR_ETAPA_CONCLUIDA', this.tab);
                }
            }
        },
        proximaEtapa(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];

            
            if (componente?.proximaEtapa) {
                componente.proximaEtapa();
            }
        },
        formatarValorFinanceiro(valorString) {

            if (valorString === null || valorString === undefined) {
                return 0;
            }
    
            if (typeof valorString !== 'string') {
                    valorString = String(valorString);
            }

            const valorNumerico = parseFloat(
                valorString
                    .replace(/\s/g, '') // remove todos os espaços (inclusive \u00A0)
                    .replace('R$', '')
                    .replace(/\./g, '')
                    .replace(',', '.')
            );

            return isNaN(valorNumerico) ? 0 : valorNumerico;
        },
        alterarSenha() {
            this.$store.commit('SET_ABRIR_ALTERAR_SENHA', true)
        },
        async ObterDados() {
            await this.$store.commit('SET_PF_SALVAR_INFO', false);
            await this.$store.commit('SET_PF_SALVAR_INFO_BANCARIAS', null);
            await this.$store.commit('SET_PF_SALVAR_INFO_CONTAS_ADICIONAIS', null);  
            await this.$store.dispatch('FETCH_PF_INFO_BASICAS');
            await this.$store.dispatch('FETCH_PF_INFO_BASICAS_REPRESENTANTES');
            await this.$store.dispatch('FETCH_PF_INFO_FINANCEIRAS');
            await this.$store.dispatch('FETCH_PF_INFO_BANCARIOS');
            await this.$store.dispatch('FETCH_PF_INFO_DECLARACOES');
            await this.$store.dispatch('FETCH_CONSULTA_BANCOS');
            await this.$store.dispatch('FETCH_CONSULTA_PAISES');
            await this.$store.dispatch('FETCH_CONSULTA_NACIONALIDADES');
            await this.$store.dispatch('FETCH_CONSULTA_OCUPACAO_PROFISSIONAL');
            await this.$store.dispatch('FETCH_CONSULTA_FORMACAO_PROFISSIONAL');
            await this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');
            await this.$store.dispatch('FETCH_CONSULTA_DISCLAIMER');
            await this.$store.dispatch('FETCH_CONSULTA_ORGAO_EMISSOR');          
        },
        async salvarConcluir() {
            if (this.salvarInformacoesPF == true && this.salvarObjConcluir == true) {
                 
                this.$store.commit('SET_PF_SALVAR_INFO', false);
                this.$store.commit('SET_FICHA_CONCLUIR', false);
                this.$store.commit('SET_ENVIAR_CADASTRO', false);


                const data = {
                    RenovacaoCadastral: this.BloquearSalvarIsolado
                };

                await api.post('/PessoaFisica/ConcluirCadastro', data)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            if(this.user.StatusCadastro > 1){

                                this.$swal({
                                    icon: 'warning',
                                    title: 'Cadastro atualizado',
                                    text: 'As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.',
                                });

                                this.user.StatusCadastro = 4;
                                this.$store.commit('SET_USER', this.user);

                            }else{

                                this.$swal({
                                    icon: 'success',
                                    title: 'Cadastro enviado para análise!',
                                    text: 'Em até 48h úteis, a empresa receberá novidades no e-mail informado.',
                                }).then((result) => {
                                    if (result.value) {
                                        this.logoff();
                                    }
                                });

                            }
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Declarações',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            } else {
                this.$store.commit('SET_PF_SALVAR_INFO', false);
                if (this.desabilitarNotificacao == true) {
                    this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', false);
                } else if (!this.Edicao) {
                        this.$swal({
                            icon: 'success',
                            title: 'Alterações realizadas com sucesso!',
                            text: 'Dados informados foram salvos com sucesso.',
                        });
                }
                this.ObterDados();
            }
        },
        async salvarInformacoesDeclaracoes() {
            if (this.salvarInformacoesPF) {
                 
                if (this.salvarObjInfoDeclaracoes == null) {
                    this.gravarDados.salvarInformacoesDeclaracoes = 1;
                    return;
                } else {
                    await api
                        .post('/PessoaFisica/declaracoes', this.salvarObjInfoDeclaracoes)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PF_SALVAR_INFO_DECLARACOES', null);
                                this.gravarDados.salvarInformacoesDeclaracoes = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesDeclaracoes = 2;
                            this.$store.commit('SET_PF_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Declarações',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
        async salvarInformacoesDispensaQuestionario() {
            if (this.salvarInformacoesPF) {
                 
                if (this.salvarObjDispensaQuestionario == null) {
                    this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                    return;
                } else {
                    await api
                        .post('/suitability/dispensa-questionario', this.salvarObjDispensaQuestionario)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PF_PJ_SALVAR_INFO_DISPENSA', null);
                                this.$store.dispatch('FETCH_PERFIL_CLIENTE');
                                this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesDispensaQuestionario = 2;
                            this.$store.commit('SET_PF_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Produtos, sessão Dispensa de Questionário.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
        async salvarInformacoesUpload() {
            if (!this.salvarInformacoesPF) {
                return;
            }
            if (this.ObjSalvarInformacoesUploadArquivos == null) {
                this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');
                this.gravarDados.salvarInformacoesUpload = 1;
                return;
            }
             
            if (this.ObjSalvarInformacoesUploadArquivos == null) {
                this.gravarDados.salvarInformacoesUpload = 1;
                return;
            } else {
                const data = {
                    documentos: this.ObjSalvarInformacoesUploadArquivos
                };
                await api
                    .post('/cliente/documentos', data)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_SALVAR_INFO_UPLOAD', null);
                            this.gravarDados.salvarInformacoesUpload = 1;
                            this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');
                            return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesUpload = 2;
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Falha ao realizar upload de documentos',
                            text: `${error.response.data.data[0]}`,
                        });
                    })
                    .finally(() => {
                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');
                    });
            }

        },
        async salvarQuestionarioAsync(){
            if (this.salvarInformacoesPF) {
                if (this.ObjSalvarQuestionario == null) {
                    this.gravarDados.salvarQuestionario = 1;
                    return;
                } else {
                await api
                .post('/suitability', this.ObjSalvarQuestionario)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$store.commit('SET_SALVAR_QUESTIONARIO', null);
                        this.gravarDados.salvarQuestionario = 1;
                        this.$store.commit("SET_MODAL_QUESTIONARIO", false);

                        if(!this.BloquearSalvarIsolado){
                            this.$swal({
                                icon: 'success',
                                title: 'Formulário preenchido com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                        }

                        this.$store.dispatch('FETCH_PERFIL_CLIENTE');

                        if(this.Edicao)
                        {
                            if(this.user.StatusCadastro == 3 
                            && !this.user.PermiteLoginEmRevisao)
                            {
                                this.logoff();
                            }
                            else
                            {
                                this.user.StatusCadastro = 4;
                            }
                        }

                    }else{
                      this.gravarDados.salvarQuestionario = 2;
                    }
                })
                .catch((error) => {
                    this.gravarDados.salvarQuestionario = 2;
                    console.log(error);
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.descricao}`,
                    });
                });
            }
            }
        },
        async salvarInformacoesBancarias() {
            if (this.salvarInformacoesPF) {
                 
                
                // Verificar se temos dados bancários para salvar
                if (this.salvarObjInfoBancarias === null || 
                    (Array.isArray(this.salvarObjInfoBancarias) && this.salvarObjInfoBancarias.length === 0)) {
                    this.gravarDados.salvarInformacoesBancarias = 1;
                    return;
                }

                try {
                    // Fazer uma única chamada para a API com todas as contas bancárias
                    const retorno = await api.post('/PessoaFisica/dadosBancarios', this.salvarObjInfoBancarias);
                    
                    if (retorno.status === 200) {
                        this.$store.commit('SET_PF_SALVAR_INFO_BANCARIAS', null);
                        this.gravarDados.salvarInformacoesBancarias = 1;
                    } else {
                        throw new Error('Falha ao salvar dados bancários');
                    }
                } catch (error) {
                    this.gravarDados.salvarInformacoesBancarias = 2;
                    const errorMessage = error.response?.data?.data?.[0] || 'Erro ao salvar os dados bancários.';
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos na aba Dados Bancários',
                        text: errorMessage,
                    });
                    this.$store.commit('SET_PF_SALVAR_INFO', false);
                }
            }
        },
        async salvarInformacoesFinanceiras() {
            if (this.salvarInformacoesPF) {
                 
                if (this.salvarObjInfoFinanceira == null) {
                    this.gravarDados.salvarInformacoesFinanceiras = 1;
                    return;
                }
                else {
                    const dadosFormatados = { ...this.salvarObjInfoFinanceira };
                    dadosFormatados.RemuneracaoMensal = this.formatarValorFinanceiro(dadosFormatados.RemuneracaoMensal);
                    dadosFormatados.OutrosRendimentos = this.formatarValorFinanceiro(dadosFormatados.OutrosRendimentos);
                    dadosFormatados.BensImoveis = this.formatarValorFinanceiro(dadosFormatados.BensImoveis);
                    dadosFormatados.BensMoveis = this.formatarValorFinanceiro(dadosFormatados.BensMoveis);
                    dadosFormatados.PatrimonioLiquido = this.formatarValorFinanceiro(dadosFormatados.PatrimonioLiquido);
                    dadosFormatados.PatrimonioTotal = this.formatarValorFinanceiro(dadosFormatados.PatrimonioTotal);
                    await api
                        .post('/PessoaFisica/dadosFinanceiros', dadosFormatados)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PF_SALVAR_INFO_FINANCEIRAS', null);
                                this.gravarDados.salvarInformacoesFinanceiras = 1;                                
                                if (this.desabilitarNotificacao == false) {
                                    this.$swal({
                                        icon: 'success',
                                        title: 'Cadastro!',
                                        text: 'Dados informados foram salvos com sucesso.'
                                    });
                                }
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesFinanceiras = 2;
                            this.$store.commit('SET_PF_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
        selectTab(tabSelected) {
            if (tabSelected < this.tab) {
                this.tab = tabSelected;
                this.$store.commit('SET_ETAPA_CADASTRO', this.tab)
            }
        },
        logoff() {
            this.$store.dispatch('auth/logout');
        },
        converterData(dataString) {
            if (dataString && dataString !== '0001-01-01T00:00:00') {
                let data = new Date(dataString);
                let ano = data.getFullYear();
                let mes = (data.getMonth() + 1).toString().padStart(2, '0');
                let dia = data.getDate().toString().padStart(2, '0');
                return `${ano}-${mes}-${dia}`;
            } else {
                return null;
            }
        },
        formatarDadosBasicos(dados) {
            return {
                DataNascimento: this.converterData(dados.DataNascimento),
                Sexo: dados.Sexo || '',
                EstadoCivil: dados.EstadoCivil || '',
                Ocupacao: dados.Ocupacao || '',
                NumeroDocumento: dados.NumeroDocumento || '',
                TipoDocumento: dados.TipoDocumento || '',
                DataEmissao: this.converterData(dados.DataEmissao),
                OrgaoEmissao: dados.OrgaoEmissao || '',
                DocumentoUf: dados.DocumentoUf || '',
                Nacionalidade: dados.Nacionalidade || '',
                Naturalidade: dados.Naturalidade || '',
                Pais: dados.Pais || '',
                NomeMae: dados.NomeMae || '',
                NomePai: dados.NomePai || '',
                CidadeNascimento: dados.CidadeNascimento || '',
                NomeConjugue: dados.NomeConjugue || '',
                CpfConjugue: dados.CpfConjugue || '',
                Logradouro: dados.Logradouro || '',
                LogradouroNumero: dados.LogradouroNumero || '',
                LogradouroComplemento: dados.LogradouroComplemento || '',
                Bairro: dados.Bairro || '',
                Cidade: dados.Cidade || '',
                Cep: dados.Cep || '',
                Uf: dados.Uf || '',
                LogradouroPais: dados.LogradouroPais || '',
                Telefone: dados.Telefone || '',
                Telefone2: dados.Telefone2 || '',
                Email: dados.Email || '',
                PoliticamenteExposta: dados.PoliticamenteExposta,
                PoliticamenteExpostaDescricao: dados.PoliticamenteExpostaDescricao || '',
                FormacaoProfissional: dados.FormacaoProfissional || '',
                Instituicao: dados.Instituicao || '',
                CnpjTrabalha: dados.CnpjTrabalha || '',
                EnderecoComercial: dados.EnderecoComercial || '',
                EnderecoComercialNumero: dados.EnderecoComercialNumero || '',
                EnderecoComercialComplemento: dados.EnderecoComercialComplemento || '',
                EnderecoComercialBairro: dados.EnderecoComercialBairro || '',
                EnderecoComercialCep: dados.EnderecoComercialCep || '',
                EnderecoComercialCidade: dados.EnderecoComercialCidade || '',
                EnderecoComercialEstado: dados.EnderecoComercialEstado || '',
                EnderecoComercialPais: dados.EnderecoComercialPais || '',
                TelefoneComercial: dados.TelefoneComercial || '',
                EmailComercial: dados.EmailComercial || '',
                EnderecoCorrespondencia: dados.EnderecoCorrespondencia || '',
                LogradouroOutro: dados.LogradouroOutro || '',
                LogradouroNumeroOutro: dados.LogradouroNumeroOutro || '',
                LogradouroComplementoOutro: dados.LogradouroComplementoOutro || '',
                BairroOutro: dados.BairroOutro || '',
                CidadeOutro: dados.CidadeOutro || '',
                UfOutro: dados.UfOutro || '',
                CepOutro: dados.CepOutro || '',
                PaisOutro: dados.PaisOutro || '',
                ClienteIncapaz: dados.ClienteIncapaz,
                ClienteEmancipado: dados.ClienteEmancipado,
                NomeRepresentante: dados.NomeRepresentante || '',
                GrauRelacionamento: dados.GrauRelacionamento || '',
                EmissorOrdem: dados.EmissorOrdem,
                DocumentoRepresentante: dados.DocumentoRepresentante || '',
                CpfRepresentante: dados.CpfRepresentante || '',
                PepRepresentante: dados.PepRepresentante,
                NomeRepresentante2: dados.NomeRepresentante2 || '',
                GrauRelacionamento2: dados.GrauRelacionamento2 || '',
                EmissorOrdem2: dados.EmissorOrdem2,
                DocumentoRepresentante2: dados.DocumentoRepresentante2 || '',
                CpfRepresentante2: dados.CpfRepresentante2 || '',
                PepRepresentante2: dados.PepRepresentante2,
                SituacaoLegal: dados.SituacaoLegal,                 
                EmailRepresentante: dados.EmailRepresentante || '',
                EmailRepresentante2: dados.EmailRepresentante2|| '',

            };
        },
        executaProximaEtapa(){
            this.tab = this.etapaCadastro;
        },
        async verificaSePassouPorTodosPassos(){
            this.$store.commit('SET_ETAPA_CONCLUIDA', this.tab);

            const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 9];

            if(this.nomeEmpresa.toUpperCase() != 'GENIAL'){
                etapasObrigatorias.push(4);
            }


            if(!Array.isArray(this.etapasConcluidas)){
                return false;
            }

            const etapasConcluidas = Array.isArray(this.etapasConcluidas)
                    ? this.etapasConcluidas.filter(e => typeof e === 'number')
                    : [];

            const todasEtapasOk = etapasObrigatorias.every(etapa => 
                etapasConcluidas.includes(etapa)
            );


            if(todasEtapasOk){
                return true;
            }else{
                this.$store.commit('SET_ETAPA_CONCLUIDA', this.tab);
                return false;
            }
        },
        async salvar(){

                this.salvarInformacoesFinanceiras();
                this.salvarInformacoesBancarias();
                this.salvarInformacoesDeclaracoes();
                this.salvarInformacoesUpload();
                this.salvarQuestionarioAsync();
                this.salvarInformacoesDispensaQuestionario();
                if (this.salvarObjInfoBasicas == null && this.salvarObjInfoEndereco == null) {
                    this.gravarDados.salvarInformacoesPF = 1;
                    return;
                } else {
                    var objInfoBasicas = null;
                    if (this.salvarObjInfoBasicas == null) {
                        objInfoBasicas = this.formatarDadosBasicos(this.informacoesBasicas);
                    } else {
                        objInfoBasicas = this.salvarObjInfoBasicas;
                    }
                    if (this.salvarObjInfoEndereco != null) {
                        objInfoBasicas.Cep = this.salvarObjInfoEndereco.Cep;
                        objInfoBasicas.Logradouro = this.salvarObjInfoEndereco.Logradouro;
                        objInfoBasicas.LogradouroNumero = this.salvarObjInfoEndereco.LogradouroNumero;
                        objInfoBasicas.LogradouroComplemento = this.salvarObjInfoEndereco.LogradouroComplemento;
                        objInfoBasicas.Bairro = this.salvarObjInfoEndereco.Bairro;
                        objInfoBasicas.Cidade = this.salvarObjInfoEndereco.Cidade;
                        objInfoBasicas.Uf = this.salvarObjInfoEndereco.Uf;
                        objInfoBasicas.LogradouroPais = this.salvarObjInfoEndereco.LogradouroPais;
                        objInfoBasicas.EnderecoCorrespondencia = this.salvarObjInfoEndereco.EnderecoCorrespondencia;
                        objInfoBasicas.CepOutro = this.salvarObjInfoEndereco.CepOutro;
                        objInfoBasicas.LogradouroOutro = this.salvarObjInfoEndereco.LogradouroOutro;
                        objInfoBasicas.LogradouroNumeroOutro = this.salvarObjInfoEndereco.LogradouroNumeroOutro;
                        objInfoBasicas.LogradouroComplementoOutro = this.salvarObjInfoEndereco.LogradouroComplementoOutro;
                        objInfoBasicas.BairroOutro = this.salvarObjInfoEndereco.BairroOutro;
                        objInfoBasicas.CidadeOutro = this.salvarObjInfoEndereco.CidadeOutro;
                        objInfoBasicas.UfOutro = this.salvarObjInfoEndereco.UfOutro;
                        objInfoBasicas.PaisOutro = this.salvarObjInfoEndereco.PaisOutro;
                        objInfoBasicas.EnderecoComercialCep = this.salvarObjInfoEndereco.EnderecoComercialCep;
                        objInfoBasicas.EnderecoComercial = this.salvarObjInfoEndereco.EnderecoComercial;
                        objInfoBasicas.EnderecoComercialNumero = this.salvarObjInfoEndereco.EnderecoComercialNumero;
                        objInfoBasicas.EnderecoComercialComplemento = this.salvarObjInfoEndereco.EnderecoComercialComplemento;
                        objInfoBasicas.EnderecoComercialBairro = this.salvarObjInfoEndereco.EnderecoComercialBairro;
                        objInfoBasicas.EnderecoComercialCidade = this.salvarObjInfoEndereco.EnderecoComercialCidade;
                        objInfoBasicas.EnderecoComercialEstado = this.salvarObjInfoEndereco.EnderecoComercialEstado;
                        objInfoBasicas.EnderecoComercialPais = this.salvarObjInfoEndereco.EnderecoComercialPais;
                    }

                    if (this.houveAlteracaoRepresentantesCriticos()) {
                        var documentoAtivo = await verificarDocumentoAtivo();
                        if (documentoAtivo) {
                            var confirmado = await confirmarReassinatura();
                            if (!confirmado){ 
                                this.gravarDados.salvarInformacoesPF = 2;
                                this.$store.commit('SET_PF_SALVAR_INFO', false);
                                return false;
                            }
                        }
                    }

                    await api
                        .post('/PessoaFisica/informacaoBasica', objInfoBasicas)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PF_SALVAR_INFO_BASICAS', null);
                                this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', null);
                                this.gravarDados.salvarInformacoesPF = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesPF = 2;
                            this.$store.commit('SET_PF_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });                            
                        });
                }
        },
    },
    watch: {
        salvouTodasAbas(newVal) {
            if (newVal) {
                this.salvarConcluir();
                if(this.solicitouProximaEtapa){
                    this.executaProximaEtapa();
                    this.$store.commit('SET_PF_SALVAR_INFO', false);
                }
                else if(this.enviarCadastro)
                {
                    this.salvarConcluir();
                }
                this.gravarDados.salvarInformacoesPF = 0;
                this.gravarDados.salvarInformacoesFinanceiras = 0;
                this.gravarDados.salvarInformacoesBancarias = 0;
                this.gravarDados.salvarInformacoesDeclaracoes = 0;
                this.gravarDados.salvarInformacoesUpload = 0;
                this.gravarDados.salvarQuestionario = 0;
                this.gravarDados.salvarInformacoesDispensaQuestionario = 0;
            }
        },
        enviarCadastro(){
            if(this.enviarCadastro){
                this.$store.commit('SET_PF_SALVAR_INFO', true);
            }
        },
        etapaCadastro() {
            if(this.Edicao)
            {
                this.tab = this.etapaCadastro;
            }
            else if(this.etapaCadastro == 0){
                this.executaProximaEtapa();
            }
            else
            {
                this.solicitouProximaEtapa = true;
            }
        },
        infoBasicas() {
            this.informacoesBasicas = this.infoBasicas;
            this.informacoesBasicas.Nome = this.user.NomeRazaoSocial;

            if (this.infoBasicas != null && this._repSnap == null) {
                this._repSnap = JSON.parse(JSON.stringify(this.infoBasicas));
            }
        },
        infoFinanceiras() {
            this.informacoesFinanceiras = this.infoFinanceiras;
        },
        infoBancarios() {
            this.informacoesBancarias = this.infoBancarios;
        },
        infoDeclaracoes() {
            this.informacoesDeclaracoes = this.infoDeclaracoes;
        },
        async salvarInformacoesPF() {


            if (this.salvarInformacoesPF) {
                if(this.BloquearSalvarIsolado)
                {
                    this.$store.commit("SET_MODAL_QUESTIONARIO", false);
                    this.$emit('update:Edicao', false);


                    if(await this.verificaSePassouPorTodosPassos() == false || !this.enviarCadastro){
                        this.$store.commit('SET_PF_SALVAR_INFO', false);
                        this.$store.commit('SET_ENVIAR_CADASTRO', false)
                        return;
                    }
                    this.$store.commit('SET_ENVIAR_CADASTRO', false);
                    this.$store.commit('SET_FICHA_CONCLUIR', true);
                }else if(this.Edicao && !this.BloquearSalvarIsolado && !this.enviarCadastro){
                    this.$store.commit('SET_PF_SALVAR_INFO', false);
                    this.$store.commit('SET_ENVIAR_CADASTRO', false)
                    this.$store.commit('SET_MODAL_AVISO', 'ModalConfirmar');
                    this.$emit('update:Edicao', false);
                    this.$store.commit('SET_FICHA_CONCLUIR', true);
                    return;
                }
                
                await this.salvar();
            }

        }
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.link__before {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid;
    max-width: 70px;

}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.info__resumo {
    display: flex;
    width: 100%;
    padding-bottom: 9px;

    .navegacao {
        display: flex;
        flex-wrap: wrap;

        .link {
            font-size: 14px;
            text-align: center;
            margin-right: 30px;
            margin-top: 20px;
            color: #667085;
            text-decoration: none;
            font-family: 'Inter', sans-serif;
            font-weight: 500;

            &.first {
                text-align: left;
            }

            &.preenchido {
                font-size: 12px;
                padding-left: 30px;
                font-weight: 500;
                position: relative;
                text-decoration: none;
                color: #12481f;
                background-image: url('@/assets/aprovado.png');
                background-repeat: no-repeat;
                background-position: 10px center;
                background-size: 20px 20px;
            }

            &.active {
                font-weight: 500;
                position: relative;
                text-decoration: none;
                color: #00064F;

                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: -9px;
                    width: 100%;
                    height: 1px;
                    background-color: #00064F;
                }
            }
        }
    }
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
    width: 80%;
    margin-left: 10%;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.info__headers {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid #EAECF0;
}

.header {
    width: 100%;
    justify-content: flex-start;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: left;
    color: #101828;
    margin-bottom: 0px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}
</style>